import * as z from 'zod';

export const subscriptionSelectSchema = z.object({
  price_id: z.string().min(1, { message: 'Select subscription.' }),
});

export type SubscriptionSelectRequest = z.infer<typeof subscriptionSelectSchema>;
